import React from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./Footer";

const PrivacyPolicy: React.FC = () => {
  return (
    <div>
      <Box sx={{ padding: "60px 40px", backgroundColor: "#f9f9f9", color: "#000", minHeight: "80vh" }}>
        <Typography variant="h4" fontWeight="bold" mb={4} align="center">
          Privacy Policy
        </Typography>

        <Typography variant="body1" paragraph>
          We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, and safeguard your data when you use our services.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          We may collect personal information such as your name, email address, phone number, identification documents, and other information necessary to provide our professional services. This may include financial information, legal documents, and business-related data.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          2. How We Collect Information
        </Typography>
        <Typography variant="body1" paragraph>
          We collect information directly from you when you engage our services, fill out forms, communicate with us, or provide documents. We may also collect information through our website, email communications, and during consultations.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          3. How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We use your information to provide professional services, respond to inquiries, verify your identity, maintain client records, comply with legal and regulatory obligations, and improve our services. We process your data only for legitimate business purposes.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          4. Information Sharing and Disclosure
        </Typography>
        <Typography variant="body1" paragraph>
          We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in service delivery, regulatory authorities when required by law, and professional advisors under strict confidentiality agreements.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          5. Data Security
        </Typography>
        <Typography variant="body1" paragraph>
          We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          6. Data Retention
        </Typography>
        <Typography variant="body1" paragraph>
          We retain your personal information for as long as necessary to fulfill the purposes outlined in this privacy policy, comply with legal obligations, resolve disputes, and enforce our agreements.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          7. Your Rights
        </Typography>
        <Typography variant="body1" paragraph>
          You have the right to access, correct, update, or delete your personal information. You may also object to or restrict certain processing of your data. To exercise these rights, please contact us using the information provided below.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          8. Cookies and Tracking Technologies
        </Typography>
        <Typography variant="body1" paragraph>
          Our website may use cookies and similar tracking technologies to enhance your browsing experience and analyze website usage. You can control cookie preferences through your browser settings.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          9. Changes to This Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on our website. Changes are effective immediately upon posting.
        </Typography>

        <Typography variant="h6" fontWeight="bold" mt={4} mb={2}>
          10. Contact Information
        </Typography>
        <Typography variant="body1" paragraph>
          For questions, concerns, or requests regarding this Privacy Policy or your personal information, please contact us through the contact information provided on our website.
        </Typography>
      </Box>
      
    </div>
  );
};

export default PrivacyPolicy;
